import { useTheme, alpha, Box, Stack, Tooltip } from "@mui/material";
import { WarningAmber, ErrorOutline } from "@mui/icons-material";
import { grey } from "@mui/material/colors";

const MobileStep = ({ Icon, title, active, completed, missingInfo, hasError, onClick }) => {
    const theme = useTheme();
    const stateColor = hasError ? "error.main" : active || completed ? "secondary.main" : grey[600];

    return (
        <Box sx={{ position: "relative" }}>
            <Tooltip
                title={
                    hasError
                        ? `${title} — error, click to fix`
                        : missingInfo
                        ? `${title} — missing information`
                        : title
                }
                arrow
                placement="top"
            >
                <Box
                    onClick={onClick}
                    sx={{
                        cursor: "pointer",
                        width: 33,
                        height: 33,
                        boxSizing: "border-box",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "1px solid",
                        borderColor: hasError ? "error.main" : active || completed ? "secondary.main" : grey[500],
                        bgcolor: active ? alpha(theme.palette.secondary.main, 0.1) : "background.paper",
                        ...theme.applyStyles("dark", {
                            borderColor: hasError ? "error.main" : active || completed ? "secondary.main" : grey[400],
                        }),
                    }}
                >
                    <Icon sx={{ fontSize: 18, color: stateColor }} />
                </Box>
            </Tooltip>
            {hasError ? (
                <ErrorOutline
                    sx={{
                        position: "absolute",
                        top: -4,
                        right: -4,
                        fontSize: 14,
                        color: "error.main",
                        bgcolor: "background.paper",
                        borderRadius: "50%",
                    }}
                />
            ) : missingInfo && (
                <WarningAmber
                    sx={{
                        position: "absolute",
                        top: -4,
                        right: -4,
                        fontSize: 14,
                        color: "warning.main",
                        bgcolor: "background.paper",
                        borderRadius: "50%",
                    }}
                />
            )}
        </Box>
    );
};

const StepperMobileNav = ({ steps = [], activeStepId, completedIdList = [], errorIdList = [], onClickStep }) => (
    <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={1.5} rowGap={1.5}>
        {steps.map((step) => (
            <MobileStep
                key={step.id}
                Icon={step.icon}
                title={step.title}
                active={step.id === activeStepId}
                completed={completedIdList.includes(step.id)}
                missingInfo={step.id !== "lastStep" && !completedIdList.includes(step.id)}
                hasError={errorIdList.includes(step.id)}
                onClick={() => onClickStep(step)}
            />
        ))}
    </Stack>
);

export default StepperMobileNav;
